import React from 'react';
import { GoogleMap, GoogleMapCircle, GoogleMapIndex, GoogleMapMarker } from './Google';
import { KakaoMap, KakaoMapCircle, KakaoMapIndex, KakaoMapMarker } from './Kakao';
import { NaverMap, NaverMapCircle, NaverMapIndex, NaverMapMarker } from './Naver';

class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      map: null
    };
  }

  setMap(map) {
    this.setState({ map });
  }

  render() {
    const map = this.state.map;
    const mapType = this.props.mapType || "naver";

    const childrens = [];
    let children = this.props.children;
    if (children instanceof Array) {
      children.forEach(v => childrens.push(v));
    } else {
      childrens.push(children);
    }

    return (
      <>
        {mapType === "naver" && (<NaverMap {...this.props} setMap={this.setMap.bind(this)} />)}
        {mapType === "kakao" && (<KakaoMap {...this.props} setMap={this.setMap.bind(this)} />)}
        {mapType === "google" && (<GoogleMap {...this.props} setMap={this.setMap.bind(this)} />)}
        {childrens.map((item, idx) => (React.cloneElement(item, { map, mapType, key: idx })))}
      </>
    );
  }
}

class MapMarker extends React.Component {
  render() {
    const mapType = this.props.mapType;
    return (
      <>
        {mapType === "naver" && (<NaverMapMarker {...this.props} />)}
        {mapType === "kakao" && (<KakaoMapMarker {...this.props} />)}
        {mapType === "google" && (<GoogleMapMarker {...this.props} />)}
      </>
    );
  }
}

class MapCircle extends React.Component {
  render() {
    const mapType = this.props.mapType;
    return (
      <>
        {mapType === "naver" && (<NaverMapCircle {...this.props} />)}
        {mapType === "kakao" && (<KakaoMapCircle {...this.props} />)}
        {mapType === "google" && (<GoogleMapCircle {...this.props} />)}
      </>
    );
  }
}

class MapIndex extends React.Component {
  render() {
    const mapType = this.props.mapType;
    return (
      <>
        {mapType === "naver" && (<NaverMapIndex {...this.props} />)}
        {mapType === "kakao" && (<KakaoMapIndex {...this.props} />)}
        {mapType === "google" && (<GoogleMapIndex {...this.props} />)}
      </>
    );
  }
}

export { Map, MapMarker, MapIndex, MapCircle };
